<div class="border border-gray-200 rounded-lg shadow-md bg-white">
  <button
    type="button"
    (click)="toggleExpanded()"
    class="w-full bg-white px-4 py-3 flex items-center justify-between hover:bg-gray-100 transition-colors rounded-t-lg">
    <span class="text-sm font-medium text-gray-700">{{ title() }}</span>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="2"
      stroke="currentColor"
      class="w-5 h-5 text-gray-600 transform transition-transform duration-200"
      [class.rotate-180]="isExpanded()">
      <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
    </svg>
  </button>
  @if (isExpanded()) {
    <div class="border-t border-gray-200 p-4">
      <div class="space-y-4">
        <div class="space-y-3">
          <label class="flex items-center gap-3 cursor-pointer">
            <input
              type="radio"
              [checked]="selectionMode() === 'withSelection'"
              (change)="setSelectionMode('withSelection')"
              name="tableSelectionMode"
              class="w-4 h-4 text-main focus:ring-main" />
            <span class="text-base">{{ 'tableOptions.withSelection' | translate }}</span>
          </label>
          <label class="flex items-center gap-3 cursor-pointer">
            <input
              type="radio"
              [checked]="selectionMode() === 'withoutSelection'"
              (change)="setSelectionMode('withoutSelection')"
              name="tableSelectionMode"
              class="w-4 h-4 text-main focus:ring-main" />
            <span class="text-base">{{ 'tableOptions.withoutSelection' | translate }}</span>
          </label>
        </div>
        <div class="mt-4">
          <button
            type="button"
            (click)="onApply()"
            [disabled]="isApplying()"
            [class]="
              'px-4 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-main focus:ring-offset-2 flex items-center justify-center gap-2 ' +
              (isApplying()
                ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                : 'border-main text-main border hover:text-white hover:bg-main/90')
            ">
            @if (isApplying()) {
              <svg
                class="w-4 h-4 animate-spin text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24">
                <circle
                  class="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  stroke-width="4" />
                <path
                  class="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
              </svg>
              <span>{{ 'tableOptions.applying' | translate }}</span>
            } @else {
              <span>{{ 'tableOptions.apply' | translate }}</span>
            }
          </button>
        </div>
      </div>
    </div>
  }
</div>
